import React from "react";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";


export default function AtsDatePicker({value,onChange, ...props}) {
    const valueDate  = value ? value : null;
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
                inputVariant="outlined"
                variant="inline"
                margin="normal"
                value={valueDate}
                onChange={onChange}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
                views={["year", "month", "day"]}
                {...props}
            />
        </LocalizationProvider>
    );
}
